import React from "react";
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap";

import { CloseButton } from "components/CloseButton";

export const PlanFactModal = ({ openModal, setOpenModal, planFact }) => {
  return (
    <Modal isOpen={openModal} toggle={() => setOpenModal(false)}>
      <ModalHeader>
        <div className="modal-title-text">План - факт приемки товара</div>
        <CloseButton onClick={() => setOpenModal(false)} />
      </ModalHeader>

      <ModalBody className="m-3">

        <Table className="table-hover accounts">
          <thead>
            <tr>
              <th>Товар</th>
              <th>План</th>
              <th>Факт</th>
            </tr>
          </thead>
          <tbody>
            {planFact.map((item) => (
              <tr
                key={item.id}
              >
                <td>
                  {item.nomenclature?.article} {item.nomenclature?.brand}
                  {item.nomenclature?.name}
                </td>
                <td>{item.count}</td>
                <td>{item.factCount}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="d-flex justify-content-end">
          <Button
            onClick={() => setOpenModal(false)}
            color="primary"
            className="button-wide"
          >
            Закрыть
          </Button>
        </div>
      </ModalBody>
    </Modal >
  );
};
